import { DateUtils, StringUtils, CommonTypes } from "neo-common";
import { Communication } from "neo-games";
import { JackpotData } from "../Datas/JackpotData";
import { Languages } from "../../../Utils/Languages";
import { Jackpot } from "../Bonuses/Jackpot";
import { GameData } from "../Datas/GameData";
import { DataManager } from "../../../Managers/DataManager";

type IProgressiveBonusLevel = Communication.Game.IProgressiveBonusLevel;

export class JackpotHistoryDialog {
    //******************************************************************************************************************
    //  SEETTINGS
    //******************************************************************************************************************

    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    protected root: HTMLElement;

    protected currency: string;

    protected historyDataElements: { [dataId: string]: HTMLElement };

    protected initialized: boolean;

    protected lastData: IProgressiveBonusLevel;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor(index: number, holder: HTMLElement) {
        this.root = this.createBaseLayout(index);
        this.currency = "";
        this.historyDataElements = {};

        holder.appendChild(this.root);
    }

    //******************************************************************************************************************
    //  INIT
    //******************************************************************************************************************

    public initialize(initData: IProgressiveBonusLevel): void {
        this.createDataSections();
        this.initialized = true;

        if (initData) {
            this.assign(initData);
        }
    }

    //******************************************************************************************************************
    //  LAYOUT
    //******************************************************************************************************************

    protected createBaseLayout(index: number): HTMLElement {
        return this.createElement("div", "jackpotHistoryDialog _disabled l-" + index);
    }

    protected createDataSections(): void {
        if (this.root) {
            let section: HTMLElement;
            let dataHolder: HTMLElement;

            //close btn only in mobile
            // if (window["CHANNEL"] === 'mobile') {
            let closeBtn = this.createElement("div", "jackpotCloseBtn", this.root);
            closeBtn.addEventListener("touchstart", (e: Event) => {
                e.preventDefault();
                e.stopPropagation();
                Jackpot.closeAllHistoryDialogs();
            });
            closeBtn.addEventListener("click", () => {
                Jackpot.closeAllHistoryDialogs();
            });
            // }

            //DataCode
            section = this.createElement("div", "jackpotHistorySection", this.root);
            this.createElement("div", "jackpotLevel", section);
            this.createDataElement("div", "jackpotTitle", JackpotData.DataCode, section);

            //DataHighestWinAmount
            section = this.createElement("div", "jackpotHistorySection jackpotHistoryData", this.root);
            dataHolder = this.createElement("div", "jackpotHistoryDataHolder", section);
            this.createTextElement(
                "div",
                "jackpotHistoryDataLabel",
                Languages.getRid("PB_HISTORYDIALOG_HIGHEST_WIN"),
                dataHolder,
            );
            this.createDataElement("div", "jackpotHistoryDataValue", JackpotData.DataHighestWinDate, dataHolder);
            this.createDataElement("div", "jackpotHistoryDataValueBig", JackpotData.DataHighestWinAmount, section);

            this.assingData(JackpotData.DataHighestWinDate, "-");
            this.assingData(JackpotData.DataHighestWinAmount, Languages.getRid("PB_HISTORYDIALOG_NODATA"));

            //DataWinCount
            section = this.createElement("div", "jackpotHistorySection jackpotHistoryData", this.root);
            dataHolder = this.createElement("div", "jackpotHistoryDataHolder", section);
            this.createTextElement(
                "div",
                "jackpotHistoryDataLabel",
                Languages.getRid("PB_HISTORYDIALOG_NUM_WINS"),
                dataHolder,
            );
            this.createDataElement("div", "jackpotHistoryDataValue", JackpotData.DataWinCount, dataHolder);

            this.assingData(JackpotData.DataWinCount, "-");

            //DataLastWinAmount
            section = this.createElement("div", "jackpotHistorySection jackpotHistoryData", this.root);
            dataHolder = this.createElement("div", "jackpotHistoryDataHolder", section);
            this.createTextElement(
                "div",
                "jackpotHistoryDataLabel",
                Languages.getRid("PB_HISTORYDIALOG_LAST_WIN"),
                dataHolder,
            );
            this.createDataElement("div", "jackpotHistoryDataValue", JackpotData.DataLastWinDate, dataHolder);
            this.createDataElement("div", "jackpotHistoryDataValueBig", JackpotData.DataLastWinAmount, section);

            this.assingData(JackpotData.DataLastWinDate, "-");
            this.assingData(JackpotData.DataLastWinAmount, Languages.getRid("PB_HISTORYDIALOG_NODATA"));

            this.showWins(false);
        }
    }

    public updateDataWithCurrency(): void {
        if (this.lastData != null) {
            this.assign(this.lastData);
        }
    }

    //******************************************************************************************************************
    //  ERRORS
    //******************************************************************************************************************

    public error(useResetAnim: boolean = false): void {
        if (useResetAnim) {
            this.root.classList.add("jackpotExpired");
        } else {
            if (this.initialized) {
                this.showWins(false);

                this.assingData(JackpotData.DataLastWinAmount, Languages.getRid("PB_HISTORYDIALOG_NODATA"));
                this.assingData(JackpotData.DataLastWinDate, "-");
                this.assingData(JackpotData.DataHighestWinAmount, Languages.getRid("PB_HISTORYDIALOG_NODATA"));
                this.assingData(JackpotData.DataHighestWinDate, "-");
                this.assingData(JackpotData.DataWinCount, "-");
            } else {
                this.initialize(null);
            }
        }
    }

    //******************************************************************************************************************
    //  ASSIGN
    //******************************************************************************************************************

    public assign(data: IProgressiveBonusLevel): void {
        this.lastData = data;

        if (this.initialized) {
            this.assingData(JackpotData.DataCode, data.code);
            this.assingData(
                JackpotData.DataLastWinAmount,
                data.lastWinAmount ? Languages.formatText(Languages.FormatMoney, data.lastWinAmount.toString()) : null,
                "money",
            );
            this.assingData(JackpotData.DataLastWinDate, data.lastWinDate, "date");
            this.assingData(
                JackpotData.DataHighestWinAmount,
                data.highestWinAmount
                    ? Languages.formatText(Languages.FormatMoney, data.highestWinAmount.toString())
                    : null,
                "money",
            );
            this.assingData(JackpotData.DataHighestWinDate, data.highestWinDate, "date");
            this.assingData(JackpotData.DataWinCount, data.winCount ? data.winCount.toString() : null);

            this.showWins();
        } else {
            this.initialize(data);
        }
    }

    private assingData(dataId: string, value: string, format: string = ""): void {
        if (this.historyDataElements && this.historyDataElements[dataId] && !StringUtils.isNullOrEmpty(value)) {
            if (format != "") {
                switch (format) {
                    case "money":
                        value = value + " " + DataManager.getDataById(GameData.DataCurrency);
                        break;
                    case "date":
                        let date = new Date(value);
                        value =
                            this.zerosPad(date.getDate(), 2) +
                            ". " +
                            this.zerosPad(date.getMonth() + 1, 2) +
                            ". " +
                            date.getFullYear();
                }
            }

            this.historyDataElements[dataId].textContent = value;
        }
    }

    private zerosPad(num: number, size: number): string {
        let s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    }

    //******************************************************************************************************************
    //  HANDLER
    //******************************************************************************************************************

    public openDialog(): void {
        this.root.classList.remove("_disabled");
    }

    public closeDialog(): void {
        this.root.classList.add("_disabled");
    }

    public isOpen(): boolean {
        return !this.root.classList.contains("_disabled");
    }

    //******************************************************************************************************************
    //  HELPER
    //******************************************************************************************************************

    public getRoot(): HTMLElement {
        return this.root;
    }

    private showWins(enabled: boolean = true): void {
        const winSections = this.root.getElementsByClassName("jackpotHistoryData");

        for (let i = 0; i < winSections.length; i++) {
            const elem = <HTMLElement>winSections[i];
            elem.style.display = enabled ? "" : "none";
        }

        const titleSections = this.root.getElementsByClassName("jackpotTitle");

        for (let i = 0; i < titleSections.length; i++) {
            const elem = <HTMLElement>titleSections[i];
            elem.style.display = enabled ? (elem.textContent == "" ? "none" : "") : "none";
        }

        //NoWins
        const noWinSections = this.root.getElementsByClassName("jackpotHistoryNoWins");
        if (enabled) {
            for (let i = 0; i < noWinSections.length; i++) {
                noWinSections[i].parentNode.removeChild(noWinSections[i]);
            }
        } else {
            if (noWinSections.length == 0) {
                const section = this.createElement("div", "jackpotHistorySection jackpotHistoryNoWins", this.root);
                this.createDataElement("div", "jackpotHistoryDataValueBig", JackpotData.DataNoWins, section);
                this.assingData(JackpotData.DataNoWins, Languages.getRid("PB_HISTORYDIALOG_NODATA"));
            }
        }
    }

    private createElement(tag: string, className: string, rootElem?: HTMLElement): HTMLElement {
        let elem = document.createElement(tag);
        elem.setAttribute("class", className);

        if (rootElem) {
            rootElem.appendChild(elem);
        }

        return elem;
    }

    private createTextElement(tag: string, className: string, text: string, rootElem?: HTMLElement): HTMLElement {
        let elem = this.createElement(tag, className, rootElem);
        elem.textContent = text;

        return elem;
    }

    private createDataElement(tag: string, className: string, dataId: string, rootElem?: HTMLElement): HTMLElement {
        let elem = this.createElement(tag, className, rootElem);

        if (this.historyDataElements) {
            this.historyDataElements[dataId] = elem;
        }

        return elem;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Jackpot/JackpotHistoryDialog.ts
 **/